import m from "mithril";
import {CardieWidget, defineWidget} from "@nebularstreams/libmui";

const

	// widget: Video Player
	VideoPlayer  = defineWidget(
		({attrs}) => m(CardieWidget, {
			title: "Recording" + (attrs.title ? " - " + attrs.title : ""),
			element: "div",
			class: "replayer",
			expandedView: () => [
				m("video", {
					alt: "video " + attrs.item.key.split("/").pop(),
					src: ([attrs.state.content.webroot, attrs.item.key].join("/")),
					preload: "auto",
					controls: true
				})
			]
		})
	);

export {VideoPlayer};
